export const icons = {
  adults: {
    viewBox: '0 0 16.3 31',
    paths: [
      {
        id: 'icoAdults',
        d:
          'M4673.469,689.4v-9.124a5.556,5.556,0,1,0-11.079,0V689.4h-2.612v-9.124c0-4.858,3.657-8.811,8.151-8.811s8.151,3.953,8.151,8.811V689.4Zm-11-24.539a5.461,5.461,0,1,1,5.46,5.461A5.461,5.461,0,0,1,4662.469,664.858Zm2.4,0a3.061,3.061,0,1,0,6.122,0h0a3.064,3.064,0,0,0-3.061-3.058v0A3.061,3.061,0,0,0,4664.869,664.858Z',
        transform: 'translate(-4659.278 -658.897)',
        fill: '#333',
        stroke: 'rgba(0,0,0,0)',
        'stroke-miterlimit': '10',
        'stroke-width': '1',
      },
    ],
  },
  amenity: {
    viewBox: '0 0 24 24',
    paths: [
      {
        id: 'icoAmenity',
        d:
          'M-1650.375-757a1.25,1.25,0,0,1-1.25-1.25v-3.524l-1.795-4.787a1.238,1.238,0,0,1-.079-.4l-.625-18.75a1.249,1.249,0,0,1,.351-.911,1.249,1.249,0,0,1,.9-.381h10a1.248,1.248,0,0,1,.9.381,1.25,1.25,0,0,1,.351.911l-.625,18.75a1.241,1.241,0,0,1-.08.4l-.369.975a1.25,1.25,0,0,1-1.611.727,1.25,1.25,0,0,1-.727-1.611l.3-.781.576-17.251h-7.416l.083,2.5h4.249a1.25,1.25,0,0,1,1.25,1.25,1.25,1.25,0,0,1-1.25,1.25h-4.166l.408,12.253,1.789,4.772a1.232,1.232,0,0,1,.089.371.008.008,0,0,0,0,0s0,.005,0,.008c0,.035,0,.07,0,.105v2.487h2.5V-762a1.25,1.25,0,0,1,1.25-1.25,1.25,1.25,0,0,1,1.25,1.25v3.75a1.25,1.25,0,0,1-1.25,1.25Zm-12.5-1.25v-11.835a.9.9,0,0,0-.146-.423l-2.344-3.1-.03-.041a3.4,3.4,0,0,1-.6-1.779c0-.019,0-.039,0-.058V-785.75a1.25,1.25,0,0,1,1.25-1.25,1.249,1.249,0,0,1,1.25,1.25v10.227a.9.9,0,0,0,.148.431l2.344,3.1c.01.013.02.026.029.04a3.4,3.4,0,0,1,.6,1.759c0,.022,0,.044,0,.067v11.875a1.25,1.25,0,0,1-1.25,1.25A1.25,1.25,0,0,1-1662.875-758.25Zm1.875-17.5a1.25,1.25,0,0,1-1.25-1.25,1.25,1.25,0,0,1,1.25-1.25h3.124a1.25,1.25,0,0,1,1.251,1.25,1.25,1.25,0,0,1-1.251,1.25Zm0-4.375a1.25,1.25,0,0,1-1.25-1.25,1.25,1.25,0,0,1,1.25-1.25h3.124a1.25,1.25,0,0,1,1.251,1.25,1.25,1.25,0,0,1-1.251,1.25Zm0-4.375a1.25,1.25,0,0,1-1.25-1.25A1.25,1.25,0,0,1-1661-787h3.124a1.25,1.25,0,0,1,1.251,1.25,1.25,1.25,0,0,1-1.251,1.25Z',
        fill: '#333',
        transform: 'translate(1666 787)',
      },
    ],
  },
  baby: {
    viewBox: '0 0 37 30',
    paths: [
      {
        id: 'icoBaby',
        d:
          'M-584.378,516.7a14.975,14.975,0,0,1-3.616-4.817,6.682,6.682,0,0,1-4.683-5.284,5.922,5.922,0,0,1-.1-1.1,5.918,5.918,0,0,1,.1-1.1,6.657,6.657,0,0,1,4.683-5.284,14.9,14.9,0,0,1,3.65-4.85,14.811,14.811,0,0,1,9.9-3.766,14.815,14.815,0,0,1,9.9,3.766,15.187,15.187,0,0,1,3.649,4.85,6.678,6.678,0,0,1,4.683,5.284,5.8,5.8,0,0,1,.1,1.1,5.808,5.808,0,0,1-.1,1.1,6.663,6.663,0,0,1-4.666,5.284,15.151,15.151,0,0,1-3.617,4.817,14.885,14.885,0,0,1-9.95,3.8A14.809,14.809,0,0,1-584.378,516.7Zm.184-4.817a11.627,11.627,0,0,0,9.749,5.282,11.629,11.629,0,0,0,9.751-5.282,11.987,11.987,0,0,0,1.432-3.1c.167.016.317.05.483.05a3.344,3.344,0,0,0,3.333-3.334,3.343,3.343,0,0,0-3.333-3.333c-.166,0-.316.034-.483.05a11.987,11.987,0,0,0-1.432-3.1,11.63,11.63,0,0,0-9.751-5.284,11.628,11.628,0,0,0-9.749,5.284,11.946,11.946,0,0,0-1.434,3.1,4.856,4.856,0,0,0-.483-.05,3.343,3.343,0,0,0-3.333,3.333,3.344,3.344,0,0,0,3.333,3.334,4.856,4.856,0,0,0,.483-.05A11.946,11.946,0,0,0-584.195,511.879Zm3.419-4.89h2.275a4.122,4.122,0,0,0,4.055,3.375,4.124,4.124,0,0,0,4.057-3.375h2.275a6.375,6.375,0,0,1-6.331,5.625A6.373,6.373,0,0,1-580.775,506.989Zm9.061-4.865a1.8,1.8,0,0,1,1.8-1.8,1.8,1.8,0,0,1,1.8,1.8,1.8,1.8,0,0,1-1.8,1.8A1.8,1.8,0,0,1-571.714,502.124Zm-9.061,0a1.8,1.8,0,0,1,1.8-1.8,1.8,1.8,0,0,1,1.8,1.8,1.8,1.8,0,0,1-1.8,1.8A1.8,1.8,0,0,1-580.775,502.124Z',
        transform: 'translate(592.778 -490.495)',
        fill: '#333',
      },
    ],
  },
  barrier_free: {
    viewBox: '0 0 26 30',
    paths: [
      {
        id: 'icoBarrierFree',
        d:
          'M10.869,5.72a2.5,2.5,0,1,0-2.5-2.5A2.5,2.5,0,0,0,10.869,5.72Zm1.765,22.922a7.769,7.769,0,0,1-7.71-7.836,7.86,7.86,0,0,1,2.7-5.931L7.49,12.424a9.919,9.919,0,0,0,5.144,18.3,10.245,10.245,0,0,0,9-6.25l-1.485-2.045a7.723,7.723,0,0,1-7.511,6.217Zm15.246-4.8H26.63l-5-6.875c-.271-.476-1.25-1.875-2.5-1.875H13.5V12.6h5c.648,0,1.346-.276,1.346-.941s-.681-.934-1.346-.934h-5V8.22c-.092-1.386-1.25-1.875-2.494-1.846S9.13,6.97,9.13,8.22v8.75c.119,1.4,1.129,1.875,2.5,1.875h7.5l4.375,5.625c.282.466,1.25,1.875,1.25,1.875H27.88a1.25,1.25,0,0,0,0-2.5Z',
        transform: 'translate(-2.88 -0.72)',
        fill: '#333',
      },
    ],
  },
  bath: {
    viewBox: '0 0 25 30',
    paths: [
      {
        id: 'icoBath',
        d:
          'M-514.786,1022H-518v-20.891A9.118,9.118,0,0,1-508.892,992a9.118,9.118,0,0,1,9.106,9.108v2.677h4.821a1.608,1.608,0,0,1,1.607,1.607,1.607,1.607,0,0,1-1.607,1.607h-12.857a1.607,1.607,0,0,1-1.607-1.607,1.608,1.608,0,0,1,1.607-1.607H-503v-2.677a5.9,5.9,0,0,0-5.892-5.893,5.9,5.9,0,0,0-5.892,5.893V1022h0Zm16.608-3.212a1.071,1.071,0,0,1,1.071-1.072,1.072,1.072,0,0,1,1.072,1.072,1.071,1.071,0,0,1-1.072,1.071A1.071,1.071,0,0,1-498.179,1018.787Zm-8.572,0a1.072,1.072,0,0,1,1.072-1.072,1.071,1.071,0,0,1,1.071,1.072,1.071,1.071,0,0,1-1.071,1.071A1.071,1.071,0,0,1-506.75,1018.787Zm4.286-2.143a1.072,1.072,0,0,1,1.072-1.072,1.071,1.071,0,0,1,1.071,1.072,1.071,1.071,0,0,1-1.071,1.071A1.071,1.071,0,0,1-502.465,1016.645Zm4.286-2.143a1.071,1.071,0,0,1,1.071-1.071,1.071,1.071,0,0,1,1.072,1.071,1.071,1.071,0,0,1-1.072,1.071A1.071,1.071,0,0,1-498.179,1014.5Zm-8.572,0a1.071,1.071,0,0,1,1.072-1.071,1.071,1.071,0,0,1,1.071,1.071,1.071,1.071,0,0,1-1.071,1.071A1.071,1.071,0,0,1-506.75,1014.5Zm4.286-2.143a1.071,1.071,0,0,1,1.072-1.071,1.071,1.071,0,0,1,1.071,1.071,1.071,1.071,0,0,1-1.071,1.072A1.072,1.072,0,0,1-502.465,1012.359Zm4.286-2.143a1.071,1.071,0,0,1,1.071-1.071,1.071,1.071,0,0,1,1.072,1.071,1.072,1.072,0,0,1-1.072,1.072A1.071,1.071,0,0,1-498.179,1010.216Zm-8.572,0a1.071,1.071,0,0,1,1.072-1.071,1.071,1.071,0,0,1,1.071,1.071,1.071,1.071,0,0,1-1.071,1.072A1.072,1.072,0,0,1-506.75,1010.216Z',
        transform: 'translate(518 -992)',
        fill: '#333',
      },
    ],
  },
  down: {
    viewBox: '0 0 30 30',
    paths: [
      {
        id: 'icoDown',
        d: 'M15,30A15,15,0,1,1,30,15,15,15,0,0,1,15,30ZM9,13.5l6,6,6-6Z',
        transform: '',
        fill: '',
      },
    ],
  },
  plus: {
    viewBox: '0 0 30 30',
    paths: [
      {
        id: 'icoPlus',
        d:
          'M-150,456a14.955,14.955,0,0,1-10.607-4.393A14.959,14.959,0,0,1-165,441a14.957,14.957,0,0,1,4.393-10.606A14.959,14.959,0,0,1-150,426a14.956,14.956,0,0,1,10.607,4.394A14.954,14.954,0,0,1-135,441a14.956,14.956,0,0,1-4.394,10.607,14.95,14.95,0,0,1-10.6,4.393Zm-8.734-23.734A12.311,12.311,0,0,0-162.353,441a12.312,12.312,0,0,0,3.618,8.735A12.309,12.309,0,0,0-150,453.352a12.306,12.306,0,0,0,8.734-3.617A12.312,12.312,0,0,0-137.647,441a12.312,12.312,0,0,0-3.619-8.734A12.3,12.3,0,0,0-150,428.648,12.305,12.305,0,0,0-158.735,432.265Zm7.163,16.128v-5.821h-5.821v-3.143h5.822v-5.821h3.142v5.822h5.822v3.143h-5.822v5.821Z',
        transform: 'translate(165.5 -425.5)',
        fill: '#333',
      },
    ],
  },
  prev: {
    viewBox: '0 0 30 30',
    paths: [
      {
        id: 'icoPrev',
        d:
          'M15,0A15,15,0,1,0,30,15,15,15,0,0,0,15,0Zm3.977,20.242-2.584,2.584L8.567,15l7.826-7.826,2.584,2.584L13.736,15Z',
        transform: 'translate(0 -0.001)',
        fill: '',
      },
    ],
  },
  bed2: {
    viewBox: '0 0 48 30',
    paths: [
      {
        id: 'icoBed2',
        d:
          'M44.445,28.333V17.778H3.333V28.333a1.667,1.667,0,1,1-3.333,0V1.667a1.667,1.667,0,1,1,3.333,0V14.444H17.778V6.666a4.444,4.444,0,0,1,4.444-4.444H36.667A11.112,11.112,0,0,1,47.778,13.333v15a1.667,1.667,0,1,1-3.333,0ZM21.111,6.666v7.778H44.445V13.333a7.787,7.787,0,0,0-7.778-7.778H22.222A1.113,1.113,0,0,0,21.111,6.666ZM5.235,7.534a5.313,5.313,0,1,1,5.313,5.313A5.319,5.319,0,0,1,5.235,7.534Zm2.223,0a3.09,3.09,0,1,0,3.09-3.09A3.093,3.093,0,0,0,7.458,7.534Z',
        transform: '',
        fill: '#333',
      },
    ],
  },
  meal: {
    viewBox: '0 0 23.5 30',
    paths: [
      {
        id: 'icoMeal',
        d:
          'M-1195.188,151.96h-3.227v-8.126c-.068-4.063-3.868-3.146-3.674-9.347.125-4,2.108-8.519,2.8-10.45,1.072-3,4.121-2.355,4.121,0V152Zm-19.232-.038v-13.6c0-2.115-.922-2.6-2-3.454-1.339-1.057-2.15-1.939-2.137-5.332V123.42a1.347,1.347,0,1,1,2.692-.021v6.4a.74.74,0,0,0,.74.741h.2a.74.74,0,0,0,.741-.741V123.37a1.257,1.257,0,0,1,1.39-1.37,1.257,1.257,0,0,1,1.39,1.37V129.8a.74.74,0,0,0,.741.741h.2a.74.74,0,0,0,.74-.741v-6.4a1.347,1.347,0,1,1,2.692.021v6.111c.013,3.393-.8,4.275-2.137,5.332-1.079.851-2,1.339-2,3.454v13.6Z',
        transform: 'translate(1218.557 -122)',
        fill: '#333',
      },
    ],
  },
  close: {
    viewBox: '0 0 30 30',
    paths: [
      {
        id: 'icoClose',
        d:
          'M30,3.021,26.979,0,15,11.979,3.021,0,0,3.021,11.979,15,0,26.979,3.021,30,15,18.021,26.979,30,30,26.979,18.021,15Z',
        transform: '',
        fill: '',
      },
    ],
  },
  info: {
    viewBox: '0 0 30 30',
    paths: [
      {
        id: 'icoInfo',
        d:
          'M-1600.839-507.179a14.946,14.946,0,0,1-4.767-3.215,14.936,14.936,0,0,1-3.214-4.768A14.9,14.9,0,0,1-1610-521a14.9,14.9,0,0,1,1.18-5.839,14.945,14.945,0,0,1,3.214-4.768,14.944,14.944,0,0,1,4.767-3.214A14.9,14.9,0,0,1-1595-536a14.9,14.9,0,0,1,5.839,1.18,14.942,14.942,0,0,1,4.767,3.214,14.943,14.943,0,0,1,3.214,4.768A14.9,14.9,0,0,1-1580-521a14.9,14.9,0,0,1-1.18,5.839,14.934,14.934,0,0,1-3.214,4.768,14.945,14.945,0,0,1-4.767,3.215A14.912,14.912,0,0,1-1595-506,14.911,14.911,0,0,1-1600.839-507.179ZM-1607.273-521A12.287,12.287,0,0,0-1595-508.727,12.286,12.286,0,0,0-1582.728-521,12.286,12.286,0,0,0-1595-533.273,12.287,12.287,0,0,0-1607.273-521Zm10.91,5.454V-521a1.363,1.363,0,0,1,1.363-1.364,1.364,1.364,0,0,1,1.364,1.364v5.454a1.364,1.364,0,0,1-1.364,1.364A1.363,1.363,0,0,1-1596.364-515.546Zm0-10.454a1.363,1.363,0,0,1,1.363-1.364,1.364,1.364,0,0,1,1.364,1.364,1.363,1.363,0,0,1-1.364,1.363A1.363,1.363,0,0,1-1596.364-526Z',
        transform: 'translate(1610 536)',
        fill: '#333',
      },
    ],
  },
  next: {
    viewBox: '0 0 30 30',
    paths: [
      {
        id: 'icoNext',
        d:
          'M15,0A15,15,0,1,0,30,15,15,15,0,0,0,15,0Zm3.977,20.242-2.584,2.584L8.567,15l7.826-7.826,2.584,2.584L13.736,15Z',
        transform: 'translate(30 30.001) rotate(180)',
      },
    ],
  },
  nosmoke: {
    viewBox: '0 0 30 30',
    paths: [
      {
        id: 'icoNosmoke',
        d:
          'M2470.627,1614.788a15,15,0,1,1,15,15A15.017,15.017,0,0,1,2470.627,1614.788Zm15,12.522a12.517,12.517,0,0,0,9.876-20.215l-8.94,8.94h2.656v2.062H2484.5l-6.566,6.566A12.458,12.458,0,0,0,2485.628,1627.311Zm-12.523-12.522a12.467,12.467,0,0,0,2.977,8.1l4.787-4.786h-3.246v-2.062h5.307l10.795-10.794a12.517,12.517,0,0,0-20.62,9.547Zm16.93,3.094v-1.812h5.617v1.812Zm-12.336-3.4-.06-.184a2.183,2.183,0,0,0,1.193-1.018,1.9,1.9,0,0,0-.094-1.554,1.888,1.888,0,0,1-.191-1.634,2.134,2.134,0,0,1,1.807-1.036l.091.637c-.493.07-1.12.242-1.313.662a1.29,1.29,0,0,0,.16,1.048l.025.045a2.514,2.514,0,0,1,.1,2.1,2.805,2.805,0,0,1-1.579,1.362Zm2.028-.248a1.561,1.561,0,0,0,.855-.73,1.358,1.358,0,0,0-.067-1.117,1.355,1.355,0,0,1-.137-1.173,1.536,1.536,0,0,1,1.3-.743l.065.458c-.354.05-.8.174-.942.474a.919.919,0,0,0,.116.752l.017.032a1.807,1.807,0,0,1,.071,1.508,2.018,2.018,0,0,1-1.133.978Z',
        transform: 'translate(-2470.127 -1599.287)',
        'stroke-miterlimit': '10',
        'stroke-width': '1',
      },
    ],
  },
  people: {
    viewBox: '0 0 30 30',
    paths: [
      {
        id: 'icoPeople',
        d:
          'M88.389-832v-9.124a5.783,5.783,0,0,0-5.539-5.988,5.783,5.783,0,0,0-5.539,5.988V-832H74.691v-9.124a5.783,5.783,0,0,0-5.539-5.988,5.783,5.783,0,0,0-5.539,5.988V-832H61v-9.124c0-4.858,3.657-8.811,8.151-8.811A8.024,8.024,0,0,1,76-845.9a8.024,8.024,0,0,1,6.849-4.038c4.494,0,8.151,3.952,8.151,8.811V-832Zm-11-24.539A5.467,5.467,0,0,1,82.849-862a5.467,5.467,0,0,1,5.461,5.461,5.467,5.467,0,0,1-5.461,5.461A5.467,5.467,0,0,1,77.388-856.54Zm2.4,0a3.064,3.064,0,0,0,3.061,3.061,3.064,3.064,0,0,0,3.061-3.061,3.064,3.064,0,0,0-3.061-3.061A3.064,3.064,0,0,0,79.788-856.54Zm-16.1,0A5.467,5.467,0,0,1,69.151-862a5.467,5.467,0,0,1,5.461,5.461,5.467,5.467,0,0,1-5.461,5.461A5.467,5.467,0,0,1,63.691-856.54Zm2.4,0a3.064,3.064,0,0,0,3.061,3.061,3.064,3.064,0,0,0,3.061-3.061,3.064,3.064,0,0,0-3.061-3.061A3.064,3.064,0,0,0,66.09-856.54Z',
        transform: 'translate(-60.5 862.5)',
        fill: '#333',
        stroke: 'rgba(0,0,0,0)',
        'stroke-miterlimit': '10',
        'stroke-width': '1',
      },
    ],
  },
  size: {
    viewBox: '0 0 30 30',
    paths: [
      {
        id: 'icoSize',
        d:
          'M690.155,1819.757h-9v-2.25h7.629l-7.629-7.629,2.123-2.121,7.627,7.629v-7.629h2.25v9A3,3,0,0,1,690.155,1819.757Zm-15,0h-9a3,3,0,0,1-3-3v-9h2.25v7.627l7.628-7.627,2.122,2.121-7.629,7.629h7.629Zm18-18H690.9v-7.629l-7.629,7.629-2.121-2.121,7.629-7.629h-7.629v-2.25h9a3,3,0,0,1,3,3Zm-20.122,0-7.628-7.627v7.627h-2.25v-9a3,3,0,0,1,3-3h9v2.25h-7.629l7.629,7.629Z',
        transform: 'translate(-663.155 -1789.757)',
        fill: '#333',
      },
    ],
  },
  tour: {
    viewBox: '0 0 29 30',
    paths: [
      {
        id: 'icoTour',
        d:
          'M-90.331-2674.021c-2.731.01-5.455.041-7.5,0-2.829-.058-3.689-1.55-3.75-3.685a2.44,2.44,0,0,1-2.51-2.651,43.981,43.981,0,0,1,.62-6.658,2.433,2.433,0,0,1,2.643-1.981c.266-2.21.583-4.3.916-5.919a7.385,7.385,0,0,1,5.925-6.217,3.741,3.741,0,0,1,3.63-2.869,3.747,3.747,0,0,1,3.668,2.885,7.457,7.457,0,0,1,5.9,6.174c.35,1.651.674,3.744.942,5.945a2.432,2.432,0,0,1,2.634,1.981,43.934,43.934,0,0,1,.62,6.656,2.439,2.439,0,0,1-2.5,2.653c-.06,2.135-.921,3.627-3.749,3.685-.765.015-1.627.021-2.549.021C-86.921-2674-88.625-2674.014-90.331-2674.021Zm-8.755-7.494a3.374,3.374,0,0,0,3.321,3.729,1.5,1.5,0,0,0,.3.018h0q5.135.052,10.271,0h0c2.376-.073,3.6-1.236,3.61-3.746v-5h-17.5Zm14.063-12.192a19.4,19.4,0,0,1,.606,4.156.625.625,0,0,0,1.243-.069,21.689,21.689,0,0,0-.42-3.532c-.53-2.456-1.613-4.425-4.013-5.165a10.572,10.572,0,0,0-5.578.046c-2.231.751-3.275,2.586-3.819,4.849a21.485,21.485,0,0,0-.5,3.765.625.625,0,0,0,1.249.024,15.963,15.963,0,0,1,.911-4.894c.76-1.835,1.988-2.742,4.333-2.872l-.789,3.006a1.494,1.494,0,0,0,1.465,1.786,1.5,1.5,0,0,0,1.459-1.818l-.865-2.982C-87.17-2697.282-85.782-2696.286-85.023-2693.707Zm-3.074-7.666a2.488,2.488,0,0,0-2.246-1.377,2.484,2.484,0,0,0-2.226,1.37,19.055,19.055,0,0,1,2.218-.123A18.493,18.493,0,0,1-88.1-2701.373ZM-85.2-2677.768Zm0,0h0Zm-10.208-1.25a2.151,2.151,0,0,1-2.395-2.361c-.03-1.294,0-2.589,0-3.883h6.25v3.747a1.25,1.25,0,0,0,1.25,1.249,1.249,1.249,0,0,0,1.25-1.249v-3.747h6.25v3.744c0,1.8-.684,2.454-2.385,2.5q-2.6.025-5.2.025Q-92.894-2678.993-95.4-2679.018Zm4.322-15.081a.746.746,0,0,1,.746-.746.746.746,0,0,1,.746.746.746.746,0,0,1-.746.746A.746.746,0,0,1-91.082-2694.1Z',
        transform: 'translate(104.586 2704.5)',
        fill: '#333',
        stroke: 'rgba(0,0,0,0)',
        'stroke-miterlimit': '10',
        'stroke-width': '1',
      },
    ],
  },
  tune: {
    viewBox: '0 0 30 30',
    paths: [
      {
        id: 'icoTune',
        d:
          'M4.5,27.833v3.333h10V27.833Zm0-20v3.333H21.167V7.833ZM21.167,34.5V31.167H34.5V27.833H21.167V24.5H17.833v10Zm-10-20v3.333H4.5v3.333h6.667V24.5H14.5v-10ZM34.5,21.167V17.833H17.833v3.333ZM24.5,14.5h3.333V11.167H34.5V7.833H27.833V4.5H24.5Z',
        transform: 'translate(-4.5 -4.5)',
      },
    ],
  },
  wifi: {
    viewBox: '0 0 30 30',
    paths: [
      {
        id: 'icoWifi',
        d:
          'M-317.26,380.5a1.5,1.5,0,0,1,1.5-1.5,1.5,1.5,0,0,1,1.5,1.5,1.5,1.5,0,0,1-1.5,1.5A1.5,1.5,0,0,1-317.26,380.5Zm5.844-4.115a7.51,7.51,0,0,0-8.688,0,1.5,1.5,0,0,1-2.092-.354,1.5,1.5,0,0,1,.355-2.092,10.509,10.509,0,0,1,12.162,0,1.5,1.5,0,0,1,.355,2.092,1.5,1.5,0,0,1-1.224.632A1.488,1.488,0,0,1-311.416,376.385Zm5.256-5.41a15,15,0,0,0-19.2,0,1.5,1.5,0,0,1-2.112-.193,1.5,1.5,0,0,1,.193-2.112,18,18,0,0,1,23.04,0,1.5,1.5,0,0,1,.193,2.112,1.5,1.5,0,0,1-1.154.54A1.493,1.493,0,0,1-306.16,370.975Zm-26.6-5.485a1.5,1.5,0,0,1,.133-2.117A25.484,25.484,0,0,1-315.76,357a25.484,25.484,0,0,1,16.862,6.371,1.5,1.5,0,0,1,.133,2.117,1.494,1.494,0,0,1-1.126.508,1.5,1.5,0,0,1-.991-.374,22.543,22.543,0,0,0-29.757,0,1.492,1.492,0,0,1-.991.375A1.5,1.5,0,0,1-332.755,365.49Z',
        transform: 'translate(333.13 -357.002)',
        fill: '#333',
      },
    ],
  },
}

export default icons
